export default "__VITE_ASSET__kTXJtIGr__"